const ErrorHandler = error => {
    if (error?.response?.message) {
        return error.response.message;
    }

    if (error?.response?.data) {
        if (error.response.data.message) {
            return error.response.data.message;
        }
    }

    return "Oops! Something happen, please contact administrator for further information";
};

export default ErrorHandler;